import React from 'react';
import { useParams, Navigate } from 'react-router-dom';
import { toolCategories } from '../data/toolsByCategory';
import slugify from '../utils/slugify';
import CategoryToolsPage from './CategoryToolsPage';

const RedirectToToolWithCategory = () => {
  const { toolId: rawToolId } = useParams<{ toolId: string }>();
  const toolId = slugify(rawToolId || '');

  console.log('[Redirect] Raw toolId:', rawToolId);
  console.log('[Redirect] Slugified toolId:', toolId);

  const matchedCategory = toolCategories.find(category => slugify(category.title) === toolId);
  if (matchedCategory) {
    return <CategoryToolsPage initialSlug={toolId} />;
  }

  let foundTool = null;
  let categoryTitle = null;

  for (const category of toolCategories) {
    for (const t of category.tools) {
      const slug = slugify(t.title);
      console.log(`→ Comparing tool slug: ${slug} === ${toolId}?`);
      if (slug === toolId) {
        foundTool = t;
        categoryTitle = category.title;
        console.log('[Redirect] Match found:', t.title, 'in category:', categoryTitle);
        break;
      }
    }
    if (foundTool) break;
  }

  if (!foundTool || !categoryTitle) {
    console.warn('[Redirect] No matching tool or category found. Redirecting to /404');
    return <Navigate to="/404" replace />;
  }

  const categorySlug = slugify(categoryTitle);
  const newUrl = `/tools/${categorySlug}/${toolId}`;

  console.log('[Redirect] Redirecting to:', newUrl);

  return <Navigate to={newUrl} replace />;
};

export default RedirectToToolWithCategory;
